var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-4 pa-0",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"pl-0"},[_c('h6',[_vm._v(_vm._s(_vm.title))])]),_c('v-card-subtitle',{staticClass:"pl-0 mt-n6 body-1"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]),_c('v-card-text',{staticClass:"pl-0"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }